import lozad from 'lozad';

export default function initLazyLoadImages() {
  const observer = lozad();
  observer.observe();
}
